export const Accordion = {
  variants: {
    pdp: {
      container: {
        borderTopWidth: "1px",
        borderColor: "border.light",
        _last: {
          borderBottomWidth: "1px",
          borderColor: "border.light",
        },
      },
      button: {
        display: "flex",
        justifyContent: "space-between",
        gap: 4,
        color: "primary.midGrey",
        fontSize: "0.875rem",
        fontWeight: "semibold",
        textTransform: "uppercase",
        lineHeight: 1.4,
        px: 0,
        py: 5,
        // clear the sticky site header (+ sticky breadcrumb band at lg) when scrolled back into view
        scrollMarginTop: { base: "calc(var(--header-height, 0px) + 8px)", lg: "calc(var(--header-height, 0px) + 58px)" },
        backgroundColor: "primary.white",
        _hover: {
          backgroundColor: "primary.white",
        },
        _selected: {
          backgroundColor: "primary.white",
        },
        _active: {
          backgroundColor: "primary.white",
        },
        _expanded: {
          borderBottomWidth: "1px",
          borderBottomColor: "border.light",
        },
      },
      panel: {
        backgroundColor: "primary.white",
        fontFamily: "graphik",
        fontSize: "0.875rem",
        lineHeight: 1.6,
        // override Chakra's default panel baseStyle (pt:2 px:4 pb:5); longhand only so px:0 suppresses the inherited 16px
        px: 0,
        pt: 4,
        pb: 6,
      },
    },
  },
  defaultProps: {
    size: "unset",
    variant: "unset",
  },
}
